import styled from 'styled-components/macro';

import {
    Button,
    Checkbox,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper
} from "@chakra-ui/react";
import {useModal} from "../../store";
import {useState} from "react";
import PayWithCrypto from "./pay_with_crypto";
import PayWithCard from "./pay_with_card";
import {themecolors} from "../../utils/themecolors";

const Description = styled.div``;
const Quantity = styled.div``;
const Heading = styled.div``;
const Total = styled.div``;
const TotalHeading = styled.span``;
const PaymentMethod = styled.div``;
const PaymentTitle = styled.h2``;
const PaymentDescription = styled.div``;
const PaymentText = styled.div``;

const BuyAwards = styled(({className, onClose}) => {
    const modal = useModal();
    const [paymentMethod, setPaymentMethod] = useState("creditCard");
    const [quantity, setQuantity] = useState(1);
    const [page, setPage] = useState(1);
    const handleContinue = async () => {
        if (page < 2) {
            setPage(page + 1);
        } else {
            onClose();
            if (paymentMethod === "creditCard") {
                modal.open(PayWithCard, {type: 'award', awards: quantity});
            } else if (paymentMethod === "cryptocurrency") {
                modal.open(PayWithCrypto, {type: 'award', awards: quantity});
            }
        }
    }
    const handlePaymentMethod = (value) => {
        setPaymentMethod(value);
    }
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{page === 1 ? 'Buy Awards' : 'Payment Method'}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6} className={className}>
                    {page === 1 &&
                        <>
                            <Description>Awards are a way to highlight great content, and to directly support the
                                platform.</Description>
                            <Heading>Quantity</Heading>
                            <Quantity>
                                <NumberInput size='sm' maxW={20} defaultValue={1} min={0} max={99} value={quantity}
                                             onChange={(value) => setQuantity(value)}>
                                    <NumberInputField/>
                                    <NumberInputStepper>
                                        <NumberIncrementStepper/>
                                        <NumberDecrementStepper/>
                                    </NumberInputStepper>
                                </NumberInput>
                            </Quantity>
                            <Total>
                                <TotalHeading>
                                    Total:
                                </TotalHeading>
                                ${parseFloat(3.99 * quantity).toFixed(2)}
                            </Total>
                        </>
                    }
                    {page === 2 &&
                        <>
                            <PaymentMethod onClick={() => handlePaymentMethod('creditCard') }>
                                <Checkbox size={'lg'} isChecked={paymentMethod === "creditCard"}/>
                                <PaymentText>
                                    <PaymentTitle>
                                        Credit Card
                                    </PaymentTitle>
                                    <PaymentDescription>
                                        Pay using a credit or debit card.
                                    </PaymentDescription>
                                </PaymentText>
                            </PaymentMethod>
                            <PaymentMethod onClick={() => handlePaymentMethod('cryptocurrency') }>
                                <Checkbox size={'lg'} isChecked={paymentMethod === "cryptocurrency"} />
                                <PaymentText>
                                    <PaymentTitle>
                                        Cryptocurrency
                                    </PaymentTitle>
                                    <PaymentDescription>
                                        Pay with privacy, using a range of cryptocurrencies.
                                    </PaymentDescription>
                                </PaymentText>
                            </PaymentMethod>
                        </>
                    }
                </ModalBody>

                <ModalFooter>

                    <Button variant="cancel" mr={3} onClick={onClose}>Close</Button>
                    <Button type='submit' variant="blue" onClick={handleContinue}>
                        Buy
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
    ${Description} {
      margin-bottom: 6px;
    }
  ${Quantity} {
    padding-top: 2px;
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${Heading} {
    margin-top: 16px;
    font-weight: 500;
    font-size: 16px;
  }
  ${Total} {
    margin-top: 16px;
    font-size: 16px;
  }
  ${TotalHeading} {
    font-weight: 500;
    font-size: 18px;
    padding-right: 8px;
  }
  ${PaymentMethod} {
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? '#343536' : '#f2f2f2'};
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 8px;
    display: flex;
    cursor: pointer;
  }
  ${PaymentText} {
    padding-left: 16px;
  }
  ${PaymentDescription} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${PaymentTitle} {
    margin: 0 !important;
  }
`;

export default BuyAwards;